export default "__VITE_ASSET__By5NvESb__"